import {
    getChequeExtensionHistory,
    getDropdowns,
    mapApprovalPermissions,
    searchCashDepositSlips,
    submitApprovalAction
} from './utils';

import { getRoleId } from 'modules/studentTransfer/transferApproval/utils';
import { getConfigs } from '../../cheque-management/approvalConfig/utils';
import { updateRequest } from "../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { getAppliedFilterCount } from 'modules/studentTransfer/components/searchStudent/studentTransfersListing/utils';
import { useCallback, useState, useEffect } from 'react';
import moment from 'moment';
import { approverActionAndDispValueMapping } from 'modules/studentTransfer/transferApproval/utils';

export const useApprovalListing = ({ isFirstTimeApiCallRequred = true, permissions, type = 'cash', filters = {}, setLoading = () => { } }) => {
    const [dropdownData, setDropdownData] = useState(null);
    const [approvalRequests, setApprovalRequests] = useState([]);
    const [globalFilter, setGlobalFilter] = useState(filters);
    const [paginationInfo, setPaginationInfo] = useState({
        currPageNo: 0,
        currPageSize: 10,
        totalRecords: 0
    });
    const [approvalActionSuccessDialogInfo, setApprovalActionSuccessDialogInfo] = useState(null);
    const [updateStatusInfo, setUpdateStatusInfo] = useState(null);
    const [roleId, setRoleId] = useState(null);
    const [approvalConfigs, setApprovalConfigs] = useState(null);
    // const [loading, setLoading] = useState(false);
    const [viewer, setViewer] = useState({
        open: false,
        s3key: "",
    });
    const [showModelInfo, setShowModelInfo] = useState(false);

    // Fetch Approval List
    const getApprovalRequests = useCallback(async ({
        filters = globalFilter,
        pageNo = paginationInfo.currPageNo,
        pageSize = paginationInfo.currPageSize,
        dropdowns = dropdownData,
        roleId: role = roleId,
        approvalConfigs: configs = approvalConfigs,
    }) => {
        try {
            setLoading(true);
            const resp = await searchCashDepositSlips({ pageNo, pageSize, filters, dropdowns, type });
            if (resp?.code !== 200) return;

            const { totalRecords, paginatedData, currentPage, totalPage } = resp.data || {};

            const mappedList = mapApprovalPermissions(
                paginatedData ?? [],
                dropdowns,
                role,
                configs
            );

            setApprovalRequests(mappedList);

            setPaginationInfo({
                currPageNo: currentPage,
                currPageSize: pageSize,
                totalRecords,
                totalPage
            });

            setGlobalFilter({
                ...filters,
                appliedFilterCount: getAppliedFilterCount(filters, ['depositSlipNo'])
            });

        } catch (err) {
            console.error("Fetch Approval Requests Error:", err);
        } finally {
            setLoading(false);
        }
    }, [globalFilter, paginationInfo, dropdownData, roleId, approvalConfigs]);

    // Update Status (Approve / Reject / Correction)
    const updateStatus = useCallback(async (reqObj) => {
        try {
            setLoading(true)
            const resp = await submitApprovalAction(reqObj, type);
            setLoading(false)
            if (resp?.code !== 200) return;
            const actionDispValue = approverActionAndDispValueMapping[reqObj.approvalAction];
            // const actionDispValue =
            //     reqObj.approvalAction === "APPROVE"
            //         ? "Approved"
            //         : reqObj.approvalAction === "REJECT"
            //             ? "Rejected"
            //             : "Sent for correction";

            const date = moment().format("DD/MM/YYYY");
            const time = moment().format("hh:mm A");
            const formattedActionDispValue = actionDispValue.charAt(0).toUpperCase() + actionDispValue.slice(1)
            type === 'cash' ?
                setApprovalActionSuccessDialogInfo({
                    heading: `Cash receipt request no. ${reqObj?.depositSlipNo} has been ${actionDispValue.toLowerCase()}.`,
                    subHeading: `${formattedActionDispValue} on ${date} at ${time} by ${reqObj?.userDetails?.employeeId}.`
                })
                : setApprovalActionSuccessDialogInfo({
                    heading: `Date extension for cheque no. ${reqObj?.referenceNumber} has been ${actionDispValue.toLowerCase()}.`,
                    subHeading: `${formattedActionDispValue} on ${date} at ${time} by ${reqObj?.userDetails?.employeeId}.`
                });

        } catch (err) {
            console.error("Update Status Error:", err);
        } finally {
            setLoading(false);
        }
    }, []);


    // Init (On Mount)
    useEffect(() => {
        const init = async () => {
            try {
                setLoading(true);

                const dropdowns = await getDropdowns(isFirstTimeApiCallRequred);
                setDropdownData(dropdowns);
                const configRequest = updateRequest({ businessAreas: dropdowns?.businessAreas });
                const paymodeTypes = type === 'cash' ? ['CASH'] : ['CHKL'];
                const [role, configResponse] = await Promise.all([
                    getRoleId(permissions?.roleType),
                    getConfigs({ ...configRequest, paymodeTypes })
                ]);

                setRoleId(role);
                setApprovalConfigs(configResponse?.data ?? []);

                await getApprovalRequests({
                    dropdowns,
                    approvalConfigs: configResponse?.data,
                    roleId: role
                });

            } catch (err) {
                console.error("Init Error:", err);
            } finally {
                setLoading(false);
            }
        };

        init();
    }, []);

    const onViewSlip = (s3key) => {
        setViewer({ open: true, s3key })
    }

    const getChequeDateExtensionLogs = async (rowData) => {
        try {
            const { referenceNumber, } = rowData || {};
            setLoading(true);
            const res = await getChequeExtensionHistory(referenceNumber)
            setShowModelInfo({
                headerDetails: rowData,
                rowList: res?.depositSlipDetailsAuditDTOList
            })
        }
        catch (err) {
            console.error("Fetch Cheque History Error:", err);
            setShowModelInfo(false)
        }
        finally {
            setLoading(false);
        }
    }

    return {
        dropdownData,
        approvalRequests,
        globalFilter,
        paginationInfo,
        approvalActionSuccessDialogInfo,
        updateStatusInfo,
        onViewSlip,
        // loading,
        viewer,
        showModelInfo,

        setViewer,
        // setLoading,
        setGlobalFilter,
        setUpdateStatusInfo,
        setApprovalActionSuccessDialogInfo,
        setShowModelInfo,

        getApprovalRequests,
        updateStatus,
        getChequeDateExtensionLogs,
    };
};